(function () {
    'use strict';

    angular.module("imApp").factory("choicePossibilityListService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1215,
                    parameters: parms || {}
                });
            },
            listChoicePossibilities: function (parms) {
                return $ihttp.post({
                    method: 1216,
                    parameters: parms || {}
                });
            },
            saveObj: function (setting) {
                return $ihttp.post({
                    method: 1818,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();
